'use client'

import { SvgIcon, type SxProps } from '@mui/material'
import LoginLogoSvg from '@/assets/login-logo.svg'

export function LoginLogo({ sx }: { sx?: SxProps }) {
  return (
    <SvgIcon viewBox="0 0 313 129" sx={sx}>
      <LoginLogoSvg />
    </SvgIcon>
  )
}
